import React, { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import { PlayFill } from "react-bootstrap-icons";
import "./VideoSection.css";

const VideoSection = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="video-section">
      <Container>
        <div className="video-wrapper">
          <img
            src="/images/projects/transparent-pool-safety/transparent-pool-safety-cover.webp"
            alt="video background"
            className="video-background"
            loading="lazy"
          />

          {/* overlay */}
          <div className="overlay"></div>

          {/* play button */}
          <div className="play-button-wrapper" onClick={() => setShow(true)}>
            <div className="pulse"></div>
            <div className="play-button">
              <PlayFill size={50} className="play-icon" />
            </div>
          </div>
        </div>

        {/* Modal */}
        <Modal
          show={show}
          onHide={() => setShow(false)}
          centered
          size="lg"
          contentClassName="video-modal"
          className="project-video-modal"
        >
          <Modal.Body className="ratio ratio-16x9">
            <video
              src="/images/projects/safety-wooden-encased-suspended-pool/safety-wooden-encased-suspended-pool-1.mp4"
              controls
              autoPlay
              className="video-player"
              loading="lazy"
            />
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default VideoSection;
